const swellDefenitions = {
	vipTiersSetting : [
	{
		option:["Subscribe & Save (15% or More)", "✓", "✓", "✓"]
	},
	{
		option:["Free Shipping (with purchases over $30)", "✓", "✓", "✓"]
	},
	{
		option:["Birthday Bonus", "", "✓", "✓"]
	},
	{
		option:["Punch Card (receive $10 and become a Platinum member after 4 orders)", "", "✓", ""]
	},
	{
		option:["Anniversary Bonus", "", "", "✓"]
	},
	{
		option:["Exclusive Shopping Events", "", "", "✓"]
	},
	{
		option:["First Access to New Product", "", "", "✓"]
	},
	{
		option:["Spontaneous Free Products", "", "", "✓"]
	},
	{
		option:["Partner Deals", "✓", "✓", "✓"]
	},
	],
	baseVIPTier: {name: "Silver", id: "base-tier-id", pointsMultiplier: "1.0", swellrequiredAmountSpent: "0"},
	referralForms: {
		newUserForm: {
			inputType: "text",
			submitText: "NEXT",
			placeholder: "Enter your email to get started...",
			formType: "new"
		},
		existingUserForm: {
			inputType: "text",
			submitText: "SEND",
			labelText: "Now, enter your friends' emails below:",
			placeholder: "Enter your friends' emails (separated by commas)",
			formType: "existing"
		}
	},
	referralShareLinks: [
		{
			class: "swell-share-referral-facebook",
			href: "javascript:void(0)",
			//icon: "fa fa-facebook-f",
			icon: "//thebeardclub.com/cdn/shop/t/733/assets/swell-facebook.svg?v=95094792710854779271765999350",
			text: "Share"
		},
		{
			class: "swell-share-referral-messenger",
			href: "javascript:void(0)",
			//icon: "fab fa-facebook-messenger",
			icon: "//thebeardclub.com/cdn/shop/t/733/assets/swell-message.svg?v=95163784188880613231765999352",
			text: "Message"
		},
		{

			class: "swell-share-referral-twitter",
			href: "javascript:void(0)",
		    //icon: "fa fa-twitter",
		    icon: "//thebeardclub.com/cdn/shop/t/733/assets/swell-tweet.svg?v=79774142078640400611765999355",
			text: "Tweet"
		},
		{
			class: "swell-share-referral-sms",
			href: "javascript:void(0)",
		 	//icon: "far fa-comment-alt",
		 	icon: "//thebeardclub.com/cdn/shop/t/733/assets/swell-sms.svg?v=50821391367548367921765999355",
			text: "SMS"
		 },

	],
}
